// import queryString from "query-string";
import React, { useContext } from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownSearch,
  //   CustomRadioButtonGroup,
  //   DropDownSearchCities,
  //   DropDownSearchProvinces,
  //   DropDownSearchSuperAgent,
} from "../../../../components";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import "./index.scss";
import { useQuery } from "react-query";
import api from "../../../../api";
import values from "../../../../values";
import Context from "../../../../context";
import {
  ICityItem,
  IItem,
  IProvinceItem,
} from "../../../../types/common.interface";
import utils from "../../../../utils";

const FilterAgent = () => {
  // ============================== Value Validation ================================

  //   const {search} = queryString.parse(window.location.search);
  const [effect, setEffect] = React.useState(false);
  const [selectedFilters, setSelectedFilters] = React.useState<any>({
    // isBlock,
    // isApproved,
    // province,
    // city,
  });

  const { requestDriver, setRequestDriver } = useContext(Context.DriverScreen);

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  // const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
  //   api.get.common.getAllProvince()
  // );
  // const getAllCity = useQuery(
  //   [values.useQueryKeys.getAllCity, requestDriver?.filters?.province],
  //   () =>
  //     api.get.common.getAllCity({
  //       provinceCode: requestDriver?.filters?.province?.Code,
  //     })
  // );
  // const userType = utils.stringHexConversion.reverse(
  //   Cookies.get(constants.USER.TYPE)
  // );

  // const getAllCompanyForAdmin = useQuery(
  //   [values.useQueryKeys.getAllCompany],
  //   () => api.post.administrator.getAllCompany({}),
  //   { enabled: userType === "ADMIN" }
  // );
  // const getAllCompanyForSuperAgent = useQuery(
  //   [values.useQueryKeys.getAllCompany, "super-agent"],
  //   () => api.post.superAgent.findCompany({}),
  //   { enabled: userType === "SUPER_AGENT_SCHOOL" }
  // );

  // const getAllCompany =
  //   userType === "ADMIN" ? getAllCompanyForAdmin : getAllCompanyForSuperAgent;

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================
  // ================================ UseEffect Call ===============================

  // ================================== JSX Content ================================
  // const companyInformationWithCompanyName = getAllCompany?.data?.result?.map(
  //   (item: any) => ({
  //     ...item,
  //     companyName: item?.companyInformation?.companyName,
  //   })
  // );

  return (
    <div className="filter-container">
      <CustomDropdownFilter title="مرتب سازی براساس">
        <>
          {/* <p className="filter-labels">استان:</p>
            <CustomDropdownSearch
              items={getAllProvince?.data?.result}
              itemName="Name"
              defaultItem={requestDriver?.filters?.province}
              onSelectItem={(event: IProvinceItem) =>
                setRequestDriver!({
                  ...requestDriver,
                  filters: {
                    ...requestDriver?.filters,
                    province: event,
                    city: undefined,
                  },
                })
              }
              placeHolder="انتخاب استان"
              isLoading={getAllProvince.isLoading}
            />
            <p className="filter-labels">شهر:</p>
            <CustomDropdownSearch
              items={getAllCity?.data?.result}
              itemName="Name"
              defaultItem={requestDriver?.filters?.city}
              onSelectItem={(event: ICityItem) =>
                setRequestDriver!({
                  ...requestDriver,
                  filters: {
                    ...requestDriver?.filters,

                    city: event,
                  },
                })
              }
              placeHolder="انتخاب شهر"
              isLoading={getAllCity.isLoading}
            /> */}
        </>
        <>
          {/* <p className="filter-labels">شرکت:</p>
            <CustomDropdownSearch
              isSearch
              items={companyInformationWithCompanyName}
              itemName="companyName"
              defaultItem={requestDriver?.filters?.company}
              onSelectItem={(event: ICompanyItem) =>
                setRequestDriver!({
                  ...requestDriver,
                  filters: {
                    ...requestDriver?.filters,

                    company: event,
                  },
                })
              }
              placeHolder="انتخاب شرکت"
            /> */}
        </>

        {/* <p className="filter-labels">جنسیت:</p>
        <CustomDropdownSearch
          items={gender}
          itemName="name"
          placeHolder="جنسیت"
          defaultItem={requestDriver?.filters?.gender}
          onSelectItem={(event: ICompanyItem) =>
            setRequestDriver!({
              ...requestDriver,
              filters: {
                ...requestDriver?.filters,
                gender: event,
              },
            })
          }
        />{" "}
        <p className="filter-labels">وضعیت تاهل:</p>
        <CustomDropdownSearch
          items={marital}
          itemName="name"
          placeHolder="وضعیت تاهل "
          defaultItem={requestDriver?.filters?.marital}
          onSelectItem={(event: ICompanyItem) =>
            setRequestDriver!({
              ...requestDriver,
              filters: {
                ...requestDriver?.filters,

                marital: event,
              },
            })
          }
        /> */}
        <>
          {/* <p className="filter-labels">وضعیت تاهل:</p> */}
          {/* <DropDownSearchSuperAgent
              defaultValue={selectedFilters?.superAgent?.name}
              onChangeSuperAgent={(selected: iItem | null) => {
                setSelectedFilters({...selectedFilters, superAgent: selected});
              }}
            /> */}
        </>
        <div className="filter-footer">
          <CustomButton2
            title="تنظیم مجدد"
            onClick={() => {
              setRequestDriver!({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );
};

const gender: IItem[] = [
  { name: "مرد", value: "MALE" },
  { name: "زن", value: "FEMALE" },
];
const marital: IItem[] = [
  { name: "مجرد", value: "SINGLE" },
  { name: "متاهل", value: "MARRIED" },
];

export default FilterAgent;
